import { Box, Group, Stack, Text } from "@mantine/core";
import { skipToken } from "@reduxjs/toolkit/query";
import React from "react";
import { selectCurrentProjectId } from "../../../../global/globalSliceCommon";
import { useAppSelector } from "../../../../hooks";
import { useGetIssueBoardsQuery } from "../IssueBoardRTK";
import { useGetMultiRegisterIssuesOnBoardsQuery } from "./multiRegisterIssuesApi";
import { selectMultiRegisterIssuesQueryArgs } from "./multiRegisterIssuesSelectors";
import MultiRegisterIssuesFilterBar from "./MultiRegisterIssuesFilterBar";
import MultiRegisterIssueBoardsPanel from "./MultiRegisterIssueBoardsPanel";
import MultiRegisterIssuesTable from "./MultiRegisterIssuesTable";
import { useMultiRegisterIssuesUrlSync } from "./useMultiRegisterIssuesUrlSync";

const MultiRegisterIssuesWrapper: React.FC = () => {
  const projectId = useAppSelector(selectCurrentProjectId);
  useMultiRegisterIssuesUrlSync();

  useGetIssueBoardsQuery(
    { projectId },
    {
      skip: projectId == null,
    },
  );

  const issuesOnBoardsQueryArgs = useAppSelector(selectMultiRegisterIssuesQueryArgs);
  const {
    data: issuesOnBoardsData,
    isLoading: isLoadingIssuesOnBoards,
    isFetching: isFetchingIssuesOnBoards,
    error,
  } = useGetMultiRegisterIssuesOnBoardsQuery(issuesOnBoardsQueryArgs ?? skipToken);

  return (
    <Stack p="md" gap="md" h="calc(100vh - 92px)" style={{ minHeight: 0 }}>
      {error != null && <Text c="red">Kunne ikke laste saker fra valgte registre.</Text>}
      {projectId != null && (
        <Group align="stretch" wrap="nowrap" gap="md" flex={1} style={{ minHeight: 0 }}>
          <Box w={280} miw={240} h="100%">
            <MultiRegisterIssueBoardsPanel />
          </Box>
          <Stack gap="md" flex={1} style={{ minWidth: 0, minHeight: 0 }}>
            <MultiRegisterIssuesFilterBar />
            <MultiRegisterIssuesTable
              issues={issuesOnBoardsData?.items ?? []}
              projectId={projectId}
              totalCount={issuesOnBoardsData?.totalCount ?? issuesOnBoardsData?.items.length ?? 0}
              isLoading={isLoadingIssuesOnBoards || isFetchingIssuesOnBoards}
            />
          </Stack>
        </Group>
      )}
    </Stack>
  );
};

export default MultiRegisterIssuesWrapper;
